// extracted by mini-css-extract-plugin
export default {"container":"x4uOR","content":"_7RRPw","title":"KMIYh","text":"v6vYg","link":"zTehn","button":"Y2pyF","mobile":"t21Hy"};